import { REQUEST_SOCKET_STEPS } from '@/shared/constants/request-socket';
import type {
  IRequestSocketProgressEvent,
  IRequestSocketProgressPayload,
  TRequestSocketStep
} from '@/shared/types/request-socket.types';

import { keysToCamelCase } from './tools';

export interface IParsedRequestSocketProgress {
  requestUuid: string;
  step: TRequestSocketStep;
}

const isRequestSocketStep = (step: string): step is TRequestSocketStep =>
  REQUEST_SOCKET_STEPS.includes(step as TRequestSocketStep);

const resolvePayload = (raw: unknown): IRequestSocketProgressPayload | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const event = raw as IRequestSocketProgressEvent;

  if (!event.payload) {
    return null;
  }

  return keysToCamelCase(event.payload);
};

export const parseRequestSocketProgress = (
  raw: unknown
): IParsedRequestSocketProgress | null => {
  const payload = resolvePayload(raw);
  const step = payload?.step;

  if (!payload?.requestUuid || !step || !isRequestSocketStep(step)) {
    return null;
  }

  return {
    requestUuid: payload.requestUuid,
    step
  };
};
